<!-- eslint-disable -->
<template lang="pug">
    .notification
        .notification-background(@click="handleCloseModal")
        .notification-box(@click.stop role="dialog" aria-modal="true")
            .notification-header
                .notification-title {{ $i18n.t(`billing.billing_tariff_${tariff.name}`) }}

            .notification-body
                .notification-form-wrapper
                    .notification-form__label
                        | {{ $i18n.t('school.school_form_availableCoursesTariff') }}
                    .notification-form__field-body
                        cs-multiselect.multiple-multiselect(
                            v-model="schoolCourses"
                            :options="courses"
                            label="name"
                            track-by="id"
                            :multiple="true"
                            :searchable="true"
                            :hide-selected="true"
                            :placeholder="$i18n.t('course.course_form_chooseDirectionPlaceholder')"
                            :close-on-select="false"
                            :menu-max-height="'calc(90vh - 220px)'"
                            @open="getCourses"
                        )
                .notification-row-wrapper
                    div(:style="{display: 'flex', alignItems: 'center', gap: '5px'}")
                       | {{ $i18n.t('trainer.trainer_main_bonusGames') }}
                       cs-checkbox(
                            v-model='bonusGamesEnabled',
                            :disabled='tariff.id !== 2'
                            :style="{marginBottom: 0}"
                       )
                .notification-row-wrapper
                    .notification-row__label
                        | {{ $i18n.t('billing.billing_subscriptions_amountOfCourses') + ': ' + tariff.restriction.courses}}
                .notification-row-wrapper
                    .notification-row__label
                        | {{ $i18n.t('billing.billing_subscriptions_amountOfTeachers') + ': ' + tariff.restriction.teachersLimit}}
                .notification-row-wrapper
                    .notification-row__label
                        | {{ $i18n.t('billing.billing_subscriptions_amountOfStudents') + ': ' + tariff.restriction.studentsLimit}}
                .notification-row-wrapper
                    .notification-row__label
                        | {{ $i18n.t('progress.progress_preview_homeworkLimit') + ': ' + homeworkLimitValue }}
                .notification-row-wrapper
                    .notification-row__label
                        | {{ $i18n.t('progress.progress_preview_gameLimit') + ': ' + timeRestrictionValue }}
                span.notification-payment {{ paymentString }}

            .notification-footer
                .notification-footer-wrapper
                    cs-button(@click="saveChanges" :disabled="saveButtonDisabled") {{ $i18n.t('homework.homework_create_save') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import CsCheckbox from '../../elements/CsCheckbox.vue';
    import CsButton from '../../elements/CsButton.vue';
    import CourseApi from '@/api/course';
    import TariffsApi from '@/api/tariffs/tariffs';
    import CsMultiselect from '@/elements/CsMultiselect.vue';

    const MENTAL_TYPE = 'mental-arithmetic';

    const MENTAL_IDS = [2, 3, 4, 5, 6, 7, 8, 19];

    export default {
        components: { CsMultiselect, CsButton, CsCheckbox },
        props: { tariff: Object },
        data() {
            return {
                checked: false,
                loadingCourses: false,
                coursesLoaded: false,
                schoolCourses: [],
                courses: [],
                bonusGamesEnabled: false,
            };
        },
        mounted() {
            if (this.tariff.id === '1') {
                this.bonusGamesEnabled = false;
            }
            if (this.tariff.id !== 2 && this.tariff.id > 2) {
                this.bonusGamesEnabled = true;
            }
        },
        methods: {
            getCourses() {
                if (this.courses.length) return;
                this.loadingCourses = true;
                CourseApi.getCoursesForTariff()
                    .then(data => {
                        const nonMental = Object.values(data).filter(c => c.type !== MENTAL_TYPE && c.id !== 16);
                        nonMental.push({
                            id: '__MENTAL__',
                            name: 'Ментальная арифметика',
                            type: MENTAL_TYPE
                        });
                        this.courses = nonMental;
                        this.loadingCourses = false;
                        this.coursesLoaded = true;
                    })
                    .catch((e) => {
                        console.log(e)
                        this.loadingCourses = false;
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
            handleCloseModal() {
                this.$emit('close');
            },
            async saveChanges() {
                if (!this.courses.length) return;
                const hasMental = this.schoolCourses.some(c => c.type === MENTAL_TYPE);

                const ids = this.schoolCourses
                    .filter(c => c.type !== MENTAL_TYPE)
                    .map(c => c.id);

                if (hasMental) ids.push(...MENTAL_IDS);

                const coursesIds = Array.from(new Set(ids));

                try{
                    await TariffsApi.changeTariff({
                        nextTariffId: this.tariff.id,
                        coursesIds: coursesIds,
                        isBonusGamesActive: this.bonusGamesEnabled,
                    });
                    this.handleCloseModal();
                    this.$router.push({ name: 'dashboard' })
                } catch (err) {
                    console.error('Change tariff error', err);
                }
            },
        },
        computed: {
            ...mapState({ authUser: state => state.auth.user }),
            paymentString() {
                let price = this.tariff.price;
                if (this.tariff.id === 2) {
                    price = this.bonusGamesEnabled ?
                        +this.tariff.actualBonusGamesPrice + +this.tariff.price :
                        +this.tariff.price
                }
                return (
                    this.$i18n.t(`billing.billing_modal_tariffTransfer`) +
                    ': ' +
                    price +
                    ' ' +
                    this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', price)
                );
            },
            homeworkLimitValue() {
                return this.tariff.restriction.homeworkLimit
                    ? this.tariff.restriction.homeworkLimit
                    : this.$i18n.t('progress.progress_preview_statusOf');
            },
            timeRestrictionValue() {
                return this.tariff.restriction.timeRestriction
                    ? this.tariff.restriction.timeRestriction + ' c'
                    : this.$i18n.t('progress.progress_preview_statusOf');
            },
            saveButtonDisabled() {
                return !this.coursesLoaded || (this.tariff.name === 'pro' && this.courses.length !== this.schoolCourses.length)
                    ||
                    (this.tariff.name !== 'pro' && this.schoolCourses.length !== this.tariff.restriction.courses)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .notification {
        position: fixed;
        inset: 0;
        z-index: $z-index-modal;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
    }

    .notification-background {
        position: absolute;
        inset: 0;
        background-color: rgba($x-color-black, $opacity-default-modal-background);
    }

    .notification-box {
        position: relative;
        width: 100%;
        max-width: 340px;
        max-height: 90dvh;
        display: grid;
        grid-template-rows: auto 1fr auto;

        overflow: hidden;
        box-sizing: border-box;
        border-radius: $border-radius-20;
        background-color: $x-color-white;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
        padding: 0;

        @include media($md) {
            max-width: 600px;
        }
    }

    .notification-header {
        background: $x-color-white;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        padding: 20px 24px 14px;
    }
    .notification-title {
        font-weight: 600;
        font-size: 22px;
        line-height: 1.2;
        text-align: center;
    }

    .notification-body {
        min-height: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 16px 24px;
        display: flex;
        flex-direction: column;
        gap: 30px;
    }

    .notification-footer {
        background: $x-color-white;
        border-top: 1px solid rgba(0, 0, 0, 0.06);
        padding: 12px 24px 18px;
    }
    .notification-footer-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .notification-form-wrapper {
        display: flex;
        align-items: start;
        gap: 8px 10px;
        flex-direction: column;
        @media (max-width: 801px) {
        }
    }
    .notification-form__label {
        line-height: 1.4;
        white-space: nowrap;
    }
    .notification-form__field-body {
        min-width: 0;
        width: 100%;
        @media (min-width: 801px) {
            width: 70%;
            min-width: 310px;
        }
    }
    .notification-payment {
        margin-top: 4px;
        font-size: 16px;
        font-weight: 500;
    }

    .notification-row-wrapper {
        display: block;
    }
    .notification-row__label {
        line-height: 1.4;
    }
</style>
